const Spinner = (props) => {
  return <span className={"a-spinner a-spinner--xs " + props.className} role="alert">
    <span className="a-spinner__circle">
      <span className="u-screen-reader-only">{props.children}</span>
    </span>
  </span>
}

export default Spinner
